/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import { classNames } from "@plasmicapp/react-web";
import { BRAND_LOGO_PATH, BRAND_NAME } from "@/wab/shared/brand";
import React from "react";

export type MarkFullColorIconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function MarkFullColorIcon(props: MarkFullColorIconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 32 32"}
      className={classNames(
        "plasmic-default__svg",
        className,
        "plasmic-default__svg plasmic_default__all plasmic_default__svg ComponentTceyg5SPl6__svg__mwBdj"
      )}
      role={"img"}
      aria-label={BRAND_NAME}
      height={"1em"}
      width={"1em"}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <image
        href={BRAND_LOGO_PATH}
        x={"0"}
        y={"0"}
        width={"32"}
        height={"32"}
        preserveAspectRatio={"xMidYMid meet"}
      ></image>
    </svg>
  );
}

export default MarkFullColorIcon;
/* prettier-ignore-end */
